import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';

interface PreviewFooterProps {
  importableCount: number;
  warningsCount: number;
  blockedCount: number;
  isDirty: boolean;
  isRefreshing: boolean;
  isConfirming: boolean;
  isBusy: boolean;
  onRefresh: () => void;
  onConfirm: () => void;
  onBack: () => void;
  onCancel: () => void;
}

export const PreviewFooter = ({
  importableCount,
  warningsCount,
  blockedCount,
  isDirty,
  isRefreshing,
  isConfirming,
  isBusy,
  onRefresh,
  onConfirm,
  onBack,
  onCancel,
}: PreviewFooterProps) => {
  const isPrimaryBusy = isRefreshing || isConfirming;

  let label: string;
  let onClick: () => void;
  let disabled = isBusy;

  if (isDirty) {
    label = 'Actualizar preview';
    onClick = onRefresh;
  } else if (importableCount === 0) {
    label = 'No hay filas para importar';
    onClick = onConfirm;
    disabled = true;
  } else {
    label = `Importar ${importableCount} transacciones`;
    onClick = onConfirm;
  }

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'stretch', sm: 'center' }}
      justifyContent="space-between"
      gap={1.5}
      sx={{ pt: 1.5, borderTop: 1, borderColor: 'divider' }}
    >
      <Box sx={{ minHeight: 20 }}>
        {blockedCount > 0 && (
          <Typography variant="caption" color="error.main" display="block">
            {blockedCount} con errores no se importarán hasta resolverlos.
          </Typography>
        )}
        {warningsCount > 0 && (
          <Typography variant="caption" color="text.secondary" display="block">
            {warningsCount} se importarán con avisos.
          </Typography>
        )}
        {blockedCount === 0 && warningsCount === 0 && (
          <Typography variant="caption" color="text.secondary" display="block">
            Todo listo para importar.
          </Typography>
        )}
      </Box>

      <Stack
        direction="row"
        gap={1}
        justifyContent={{ xs: 'space-between', sm: 'flex-end' }}
        sx={{ flexShrink: 0 }}
      >
        <Button onClick={onCancel} disabled={isBusy} color="inherit">
          Cancelar
        </Button>
        <Button onClick={onBack} disabled={isBusy}>
          Atrás
        </Button>
        <Button
          variant="contained"
          onClick={onClick}
          disabled={disabled}
          startIcon={isPrimaryBusy ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          {label}
        </Button>
      </Stack>
    </Stack>
  );
};
